export default __webpack_public_path__ + "static/media/ApplePayMobile.cea58a08.svg";